/* globals Image */

export const redditAccountCreationEvent = () => {
  var i = new Image()
  i.src = 'https://alb.reddit.com/snoo.gif?q=CAAHAAABAAoACQAAAAAA7xUOAA==&s=RGC2UDUA43GMsxM-RWyC1n_k5kkF8YB_CfcyBdhIMtw='
}



// WEBPACK FOOTER //
// ./src/js/analytics/reddit-analytics.js